import { AjaxSource } from './AjaxSource';
import type { AjaxSourceOptions } from './Sources.types';

const defaultOptions = (apiPath) => ({
    url: `https://data.goteborg.se/${apiPath}84e5851f-14d2-4a8f-b171-5754613d40a4?format=json`,
});

export class GöteborgsStadSource extends AjaxSource {
    constructor(apiPath: string, options?: AjaxSourceOptions) {
        super({ ...defaultOptions(apiPath), ...options });
    }
}
